import { useCallback } from "react";
import { uploadToADLS } from "../bondRetrievalUtils";
import { buildTrusteePayload } from "../bondRetrievalPayloadBuilders";
import { calculatePremium } from "../../../../globals/utils/commons";
import useBondRetrieveBase from "./useBondRetrieveBase";

function useTrusteeBondRetrieve() {
  const buildPayload = useCallback(
    (globalState, status, billingMethod, isIndemnityReceived) =>
      buildTrusteePayload(globalState, status, billingMethod, isIndemnityReceived),
    []
  );

  return useBondRetrieveBase("trustee", {
    buildPayload,
    calculateCorrectionPremium: (amount) => calculatePremium(amount),
    extraReturn: () => ({ uploadToADLS }),
  });
}

export default useTrusteeBondRetrieve;
